import { LoadingButton } from "@mui/lab";
import {
  Divider,
  FormControl,
  Link,
  TextField,
  Typography,
} from "@mui/material";
import Box from "@mui/material/Box";
import { useFormik } from "formik";
import { useDispatch } from "react-redux";
import { asyncLogin, setCurrentScreen } from "../../features/auth/authSlice";
import Alert from "../../utils/alert";
import config from "../../utils/config";
import { Roles } from "../../utils/helper";
import { userLogin } from "../../utils/validators";
import PasswordInput from "../PasswordInput";

const Login = () => {
  const dispatch = useDispatch(),
    changeScreen = (screen) => dispatch(setCurrentScreen(screen)),
    model = {
      email: "",
      password: "",
    },
    {
      values,
      isSubmitting,
      handleBlur,
      handleChange,
      handleSubmit,
      errors,
      touched,
      handleFocus,
    } = useFormik({
      validationSchema: userLogin,
      initialValues: model,
      onSubmit: async (value) => {
        try {
          const { companyStaff, ...roles } = Roles;
          const res = await dispatch(asyncLogin(value)).unwrap(),
            user = res?.data?.user;
          console.log(res?.data);

          // Check if user is new and needs to change password
          if (res?.success && res?.data?.newUser) {
            Alert({
              type: "info",
              message:
                "Welcome! Please change your default password to continue.",
            });
            dispatch(setCurrentScreen("change-password"));
            // window.location.href = config.routes.changeDefaultPassword;
            return;
          }

          // Restrict role access
          if (res?.success && !res?.data?.newUser) {
            if (Object.values(roles).includes(user?.role?.[0])) {
              let redirectUrl = config.routes.dashboard;
              if (user?.role?.[0] === Roles.hospitalStaff)
                redirectUrl = config.routes.hospitals.patients.patient;

              window.location.href = redirectUrl;
            } else {
              Alert({
                type: "error",
                message:
                  "You do not have access to this portal. Please download and use our mobile app. Thank you.",
              });
            }
          }
        } catch (error) {
          console.log(error);
        }
      },
    });

  return (
    <Box className="pt-24">
      <Typography component={"h4"} variant={"h4"} className="font-bold ">
        Sign In
      </Typography>

      <Typography className="text-[14px] text-gray-600">
        Enter your login details.
      </Typography>

      <Box
        component="form"
        marginTop="2em"
        noValidate
        onSubmit={handleSubmit}
        data-cy="login-form"
      >
        <FormControl required fullWidth>
          <TextField
            className="w-full bg-white"
            id="email"
            label="Email Address"
            name="email"
            value={values.email}
            required
            onChange={handleChange}
            onBlur={handleBlur}
            onFocus={handleFocus}
            error={errors.email && touched.email}
            helperText={errors.email && touched.email ? errors.email : ""}
            type="email"
            inputProps={{
              "data-cy": "email-input",
            }}
          />
        </FormControl>

        <PasswordInput
          {...{
            value: values.password,
            label: "Password",
            error: errors.password && touched.password,
            helperText:
              errors.password && touched.password ? errors.password : "",
            name: "password",
            onChange: handleChange,
            onBlur: handleBlur,
            required: true,
            inputProps: {
              "data-cy": "password-input",
            },
          }}
        />

        <Box display="flex" justifyContent="flex-end">
          <Link
            className="no-underline cursor-pointer mt-2"
            onClick={(_) => changeScreen("forgotPassword")}
            data-cy="forgot-password-link"
          >
            Forgot Password?
          </Link>
        </Box>

        <LoadingButton
          className="my-6 rounded-[10px] bg-[var(--c-primary-0)] hover:bg-[var(--c-primary-1)]"
          sx={{
            ".MuiLoadingButton-loadingIndicatorCenter": {
              color: "var(--c-bg-color) !important",
            },
          }}
          size="large"
          type="submit"
          variant="contained"
          fullWidth
          loading={isSubmitting}
          data-cy="login-submit-button"
        >
          Sign In
        </LoadingButton>

        <Divider> OR </Divider>

        <Typography
          component="p"
          textAlign="center"
          fontSize="20px"
          marginTop="1em"
        >
          Don't have an account?{" "}
          <Link
            className="no-underline cursor-pointer"
            onClick={(_) => changeScreen("home-page")}
          >
            Sign Up
          </Link>{" "}
        </Typography>
      </Box>
    </Box>
  );
};

export default Login;
